import React, { useEffect, useState } from "react";
import { Alert, Row, Col } from "shards-react";
import PasswordForm from "../../components/password-form/PasswordForm";
import logo_card from "../../images/avatars/lock.svg";
import AuthService from "../../services/auth-service/AuthService";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import useCurrentPath from "../../hooks/useCurrentPath";

const CreateNewPassword = () => {
    const [isFetching, setIsFetching] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [msgError, setMsgError] = useState("");
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordConfirmation, setnewPasswordConfirmation] = useState(
        false
    );
    const [success, setSuccess] = useState(false);
    const [showBackLink] = useState(false);
    const [, setScore] = useState(0);
    const navigate = useNavigate();
    const currentPath = useCurrentPath();

    useEffect(() => {
        const isAbleToResetPassword =
            currentPath &&
            (currentPath === "/redefine_password/:token" ||
                currentPath === "/reset_password" ||
                currentPath === "/manager/reset_password" ||
                currentPath === "/manager/redefine_password/:token");

        if (!AuthService.isFirstLogin() && !isAbleToResetPassword) {
            navigate({ pathname: "/applications/1" });
        }
    }, []);

    const changeInputValue = event => {
        event.preventDefault();
        const target = event.target;
        if (target.name === "currentPassword") {
            setCurrentPassword(target.value);
        }
        if (target.name === "newPassword") {
            setNewPassword(target.value);
        }
        if (target.name === "newPasswordConfirmation") {
            setnewPasswordConfirmation(target.value);
        }
    };

    const resetPassword = async event => {
        event.preventDefault();
        setMsgError("");
        setHasError(false);
        // const email = location && location.state && location.state.email;
        if (!currentPassword) {
            setMsgError("É necessário informar a senha atual");
            setHasError(true);
            return;
        }

        if (!newPassword) {
            setMsgError("É necessário informar a nova senha");
            setHasError(true);
            return;
        }

        if (newPasswordConfirmation !== newPassword) {
            setMsgError(
                "O campo Confirmar Nova Senha deve ser preenchido, de forma identica ao campo Nova Senha"
            );
            setHasError(true);
            return;
        }

        if (newPassword === currentPassword) {
            setMsgError("A nova senha não pode ser igual a senha atual");
            setHasError(true);
            return;
        }

        setIsFetching(true);

        try {
            await AuthService.createPassword({ currentPassword, newPassword });
            setIsFetching(false);
            setSuccess(true);
            setHasError(false);
            setMsgError(
                "Senha alterada com sucesso, em alguns instantes, realize o login novamente."
            );
            setTimeout(() => {
                navigate({ pathname: "/" });
            }, 5000);
        } catch (e) {
            setIsFetching(false);
            setSuccess(false);
            setHasError(true);
            setMsgError("Não foi possível alterar a senha.");
        }
        setIsFetching(false);
    };

    const onChangeScore = score => {
        setScore(score);
    };

    const informations = { isFetching, hasError, msgError, src: logo_card };
    const infoFirstInput = {
        type: "password",
        label: "Nova Senha",
        name: "newPassword",
        value: newPassword,
        valid:
            newPassword && newPassword === newPasswordConfirmation
                ? true
                : false
    };

    const infoSecondtInput = {
        type: "password",
        label: "Confirmar Nova Senha",
        name: "newPasswordConfirmation",
        value: newPasswordConfirmation,
        valid:
            newPasswordConfirmation && newPasswordConfirmation === newPassword
                ? true
                : false
    };

    const extraInput = {
        type: "password",
        label: "Senha Atual",
        name: "currentPassword",
        value: currentPassword,
        valid: currentPassword && currentPassword !== newPassword ? true : false
    };

    const configButton = {
        theme: "primary",
        label: "Resetar Senha"
    };
    const actions = {
        formSubmit: resetPassword,
        onchange: changeInputValue,
        onChangeScore: onChangeScore
    };

    return (
        <div id="create-new-password-container">
            <Row>
                <Col sm="12">
                    {success ? <Alert theme="success">{msgError}</Alert> : null}
                </Col>
                <Col sm="12">
                    {hasError ? <Alert theme="danger">{msgError}</Alert> : null}
                </Col>
            </Row>
            <div className="form-auth--container">
                <PasswordForm
                    screen="createNewPassword"
                    showIcon={true}
                    informations={informations}
                    showBrand={false}
                    configFirstInput={infoFirstInput}
                    configSecondtInput={infoSecondtInput}
                    configExtraInput={extraInput}
                    configButton={configButton}
                    message="Criando nova senha..."
                    actions={actions}
                    showBackLink={showBackLink}
                />
            </div>
        </div>
    );
};

export default CreateNewPassword;
